const fr = {
  "app.webcheckin.title": "Enregistrement en ligne",
  "app.webcheckin.no_booking": "N° de réservation",
  "app.webcheckin.customer": "Client",
  "app.webcheckin.channel": "Canal de réservation",
  "app.webcheckin.reservation_detail": "Détails de la réservation",
  "app.webcheckin.experiences": "Expériences",
  "app.webcheckin.meal_plan": "Formule de repas",
  "app.webcheckin.nights_quantity": "{nights} nuits",
  "app.webcheckin.reserved rooms": "Chambres réservées",
  "app.webcheckin.intro_info":
    "Vous pouvez désormais effectuer votre check-in de manière rapide et sans complications.",
  "app.webcheckin.view_guest": "Voir les invités enregistrés",
  "app.webcheckin.max_accommodation": "Jusqu’à {max} invités",
  "app.webcheckin.register_guest": "Enregistrer des invités",
  "app.webcheckin.hello": "Bonjour, ",
  "app.webcheckin.name_guest": "Nom",
  "app.webcheckin.type_guest": "Type",
  "app.webcheckin.melhous_btn": "VOIR MELHOUS",
  "staff.supply.no_signature": "Aucune signature ajoutée",
  "app.webcheckin.contact": "Contact",
  "app.webcheckin.experiences.melhous":
    "Application exclusive pour les clients",
  "app.webcheckin.arrive.date": "Arrivée",
  "app.webcheckin.departure.date": "Départ",
  "app.webcheckin.melhos.description":
    "Avec Melhous, vous avez désormais un accès exclusif aux meilleurs services et expériences réservés aux clients. Tout ce que vous devez savoir sur nous se trouve  ",
  "app.webcheckin.melhos.click": "ici.",
  "app.webcheckin.experiences.description":
    "Profitez des meilleures expériences que nous avons préparées pour vous.",
  "app.webcheckin.msg_ok": "Enregistrement effectué avec succès.",
  "app.webcheckin.extra_fields": "Champs supplémentaires",
  "app.webcheckin.placeholder.description": "Écrivez la description",
  "app.webcheckin.main_guest_description":
    "Cet enregistrement concernera le client principal de la réservation.",
};

export default fr;
